import React from 'react';
import { Upload, Loader2 } from 'lucide-react';

/**
 * Image upload component with OCR processing
 * @param {Object} props
 * @param {Function} props.onImageUpload - Callback when image is uploaded
 * @param {boolean} props.isProcessing - Whether OCR is processing
 * @param {string} props.imagePreview - Preview image URL
 * @param {Object} props.translations - Translation object
 */
const ImageUpload = ({
    onImageUpload,
    isProcessing,
    imagePreview,
    translations
}) => {
    return (
        <div className="mb-8">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                {translations.uploadTitle}
            </label>
            <div className="relative">
                <input
                    type="file"
                    accept="image/*"
                    onChange={onImageUpload}
                    className="hidden"
                    id="card-upload"
                    disabled={isProcessing}
                />
                <label
                    htmlFor="card-upload"
                    className={`flex flex-col items-center justify-center w-full h-48 border-2 border-dashed rounded-lg cursor-pointer transition-colors ${isProcessing
                        ? 'border-gray-300 bg-gray-50'
                        : 'border-gray-300 hover:border-gray-400 bg-gray-50 hover:bg-gray-100'
                        }`}
                >
                    {imagePreview ? (
                        <img
                            src={imagePreview}
                            alt="Business card preview"
                            className="h-full object-contain"
                        />
                    ) : isProcessing ? (
                        <div className="flex flex-col items-center">
                            <Loader2 className="w-12 h-12 text-cabaza-pink animate-spin mb-2" />
                            <span className="text-sm text-gray-600">{translations.analyzing}</span>
                        </div>
                    ) : (
                        <div className="flex flex-col items-center px-4">
                            <Upload className="w-12 h-12 text-cabaza-purple mb-2" />
                            <span className="text-sm text-gray-600 text-center">
                                {translations.uploadClick}<br />
                                {translations.uploadCardText}
                            </span>
                        </div>
                    )}
                </label>
            </div>
        </div>
    );
};

export default ImageUpload;
